module.exports = __webpack_public_path__ + "static/img/bg_phone_new.373e0aea.webp";